import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  sortable: {
    base: {
      color: theme.colors.accents.secondary,
    },
    clickable: {
      cursor: 'pointer',
      ':hover': {
        color: theme.colors.accents.secondaryHover,
      },
      ':active': {
        color: theme.colors.accents.secondaryActive,
      },
    },
    active: {
      color: theme.colors.accents.secondaryHover,
    },
  },
  icon: {
    base: {
      verticalAlign: 'sub',
    },
  },
})
